
"use client";

import { Dropdown, DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger } from "@heroui/dropdown"
import { User } from "@heroui/user"
import { Input } from "@heroui/input"
import React, { useState, useRef, useEffect } from "react"
import { Button } from "@heroui/button"
import { setCookie, getCookie, removeCookie } from "typescript-cookie";
import axios, { AxiosResponse } from "axios"; 
import { Form } from "@heroui/form"
import { Link, LinkIcon } from "@heroui/link";
import { siteConfig } from "@/config/site";
import { OpendoorIcon } from "@/components/icons";
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/popover";

class UserObj{
    type : number = -1
    data : any 
}

const GetUser = async (Token : any) => {
    let u = new UserObj()

    if (Token != undefined){

        u.data = await (await axios.get( siteConfig.Backend_URL + 'user', { headers: { "Authorization" : `Bearer ${Token}`}})).data
        
        if (u.data != undefined){
            u.type = 0
        }
    }
    return(u)
}

export default function UserBar() {

    const [LoginError, setLoginError] = useState('')
    const onSubmit = (formData : React.FormEvent<HTMLFormElement>) => {

        formData.preventDefault();

        const data = Object.fromEntries(new FormData(formData.currentTarget))

        const login_data = new FormData()

        login_data.append('username', data.email)
        login_data.append('password', data.password)

        const response = axios.post(siteConfig.Backend_URL + 'user/Login',login_data).then((response) => {
            if (response.status === 200) {    

                setCookie('sessionKey', response.data, { expires: 700, path : "/" });
                GetUser(response.data).then(function (u){
                    SetActualUser(u)
                    SetActualPic("data:image/png;base64," + u.data.picture)
                }).finally()
            }else {
                removeCookie('sessionKey');
                setLoginError('Chyba serveru session not created')
                let id = setInterval(() => { setLoginError(''); clearInterval(id);}, 1000);
            }
        }).catch((error) => {
            switch (error.status){
                case 401:
                    setLoginError('EE! Zkus jine heslo.') 
                    break;
                default:
                    setLoginError('Sorry spadl mi server. Err ' + error.status)
                    break; 
            }
            removeCookie('sessionKey');
            let id = setInterval(() => { setLoginError(''); clearInterval(id);}, 1000);
        })
    };

 useEffect(() => {
    var Token =  undefined
    try{ Token = getCookie('sessionKey')}catch{}

    if (Token) {
        GetUser(Token).then(function (u){
        SetActualUser(u)
        SetActualPic("data:image/png;base64," + u.data.picture)
       }).finally()
    }else{
        SetActualUser(new UserObj)
    }
}, [])

const [ActualUser, SetActualUser] = useState<UserObj>(new UserObj);
const [ActualPic, SetActualPic] = useState("");

    return(
        <div className="basis-1/7 flex gap-4 min-w-[160px]">
            <div>
            {ActualUser.type != -1 ? 
            <Link color="foreground" href="/door">
                <OpendoorIcon width={40} height={40}/>
                {"Door"}
            </Link>
            :<></>
            }</div>

            <div>
            <Dropdown      
            showArrow
            classNames={{
                base: "before:bg-default-200", // change arrow background
                content: "p-0 border-small border-divider bg-background",
            }}
            radius="sm"
            >
                <DropdownTrigger variant="ghost"> 
                    {ActualUser.type == -1 ? 
                        <User avatarProps={{ src: "../images/no-profile-picture-icon.png", }} name = "Login" />
                        : 
                        <User avatarProps={{src: ActualPic}}
                        name={ActualUser.data.name + " " + ActualUser.data.surname}/>
                          }
                </DropdownTrigger> 
                <DropdownMenu>
                    <DropdownSection>
                         {ActualUser.type == -1 ? 
                            <DropdownItem key="Login" isReadOnly>
                                <Form
                                    validationBehavior="aria"
                                    className="w-full justify-center items-center space-y-4"
                                    onSubmit={onSubmit}
                                    >
                                    <div className="flex flex-col gap-2 max-w-md">

                                        <Input
                                        isRequired
                                        errorMessage={({validationDetails}) => {
                                            if (validationDetails.valueMissing) {
                                            return "Please enter your email";
                                            }
                                            if (validationDetails.typeMismatch) {
                                            return "Please enter a valid email address";
                                            }
                                        }}
                                        label="Email"
                                        labelPlacement="outside"
                                        name="email"
                                        placeholder="Enter your email"
                                        type="email"
                                        style={{fontSize: 17}}
                                        />

                                        <Input
                                        isRequired
                                        label="Password"
                                        labelPlacement="outside"
                                        name="password"
                                        placeholder="Enter your password"
                                        type="password"
                                        style={{fontSize: 17}}
                                        />

                                        <div className="hiden flex gap-4 sm:flex">

                                            <Popover backdrop="opaque" placement="bottom" color="danger" isOpen={LoginError != ""} >
                                                <PopoverTrigger>
                                                    <div className="hiden flex gap-4 sm:flex w-full">
                                                    <Link href="/acount/create">
                                                        <Button  className="w-full" color="warning" variant="bordered">
                                                            Register
                                                        </Button>
                                                    </Link>
                                                    <Button className="w-full" type="submit" color="primary" variant="bordered">
                                                        Login
                                                    </Button>
                                                    </div>
                                                </PopoverTrigger>
                                                <PopoverContent>
                                                    {LoginError}
                                                </PopoverContent>
                                            </Popover>
                                        </div>
                                    </div>
                                </Form>
                            </DropdownItem>
                        :<>
                        {
                            ActualUser.data.role != 0 ?
                                    <>
                                        <DropdownItem key="MyPlan" href="/acount/MyPlan" color="success">My Plan</DropdownItem> 
                                        <DropdownItem key="MyAcount" href="/acount/MyData">My data</DropdownItem>
                                        <DropdownItem key="AdminPanel" href="/acount/Admin">Admin panel</DropdownItem>
                                    </>
                                :
                                    <></>
                            }
                            <DropdownItem key="Logout" color="danger" onClick={() => {
                                removeCookie('sessionKey');
                                SetActualUser(new UserObj)
                            }}>Logout</DropdownItem></>
                        }
                    </DropdownSection>
                </DropdownMenu>
            </Dropdown>
            </div>
        </div>
    )   
}
